import { render, staticRenderFns } from "./amine.vue?vue&type=template&id=afe2d68e&"
import script from "./amine.vue?vue&type=script&lang=js&"
export * from "./amine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports